import napStyles from './../nap.json'

const greyMetalLink = {
  color: napStyles.colors.SecondaryGreyMetal,
  borderBottom: `1px solid ${napStyles.colors.SecondaryGreyMetal}`
}

const primaryWhiteLink = {
  color: napStyles.colors.PrimaryWhite,
  borderBottom: `1px solid ${napStyles.colors.PrimaryWhite}`
}

export default {
  name: '4',
  type: 'Label',
  default: {
    color: napStyles.colors.PrimaryBlack,
    inverseColor: napStyles.colors.PrimaryWhite,
    borderBottom: `1px solid ${napStyles.colors.PrimaryBlack}`
  },
  hover: greyMetalLink,
  inverseDefault: primaryWhiteLink,
  inverseHover: primaryWhiteLink
}
